import React, { FC, RefObject, Dispatch, useState } from 'react';
import styled from '@emotion/styled';
import { CloseIcon, InfoIcon } from '../../icons';

const Tooltip = styled.div`
  display: flex;
  position: absolute;
  top: -12px;
  left: 50%;
  z-index: 50;
  transform: translate(-50%, -100%);
  width: 22rem;
`;

const PopoverContent = styled.span`
  position: relative;
  padding: 1rem 1.25rem;
  left: 50%;
  transform: translate(-50%, 0%);
  max-width: 22rem;
  font-size: 12px;
  background-color: #fff;
  box-shadow: 0px 3px 7px rgba(0, 0, 0, 0.25);
  border-radius: 6px;
  word-wrap: normal;
  word-break: keep-all;
  /* Tooltip Arrow is basically a div box rotated 45 degrees */
  &:before {
    content: '';
    width: 12px;
    height: 12px;
    left: 50%;
    transform: translate(-50%, -50%) rotate(45deg);
    position: absolute;
    pointer-events: none;
    display: flex;
    background: #fff;
    top: 100%;
  }
`;

const TooltipCloseButton = styled(CloseIcon)`
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  color: #bdcad2;
  width: 0.5rem;
  height: 0.5rem;
  cursor: pointer;
`;

const PopoverWrapper = styled.div`
  position: relative;
  height: 24px;
  width: 24px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin-left: 0.5rem;
  & svg {
    cursor: pointer;
  }
`;
interface PopoverProps {
  targetRef?: RefObject<Element>;
  onClose: Dispatch<void>;
  opened: boolean;
}

const Popover: FC<PopoverProps> = props => {
  return (
    <Tooltip style={{ display: props.opened ? 'flex' : 'none' }}>
      <PopoverContent>
        <TooltipCloseButton onClick={() => props.onClose()} />
        {props.children}
      </PopoverContent>
    </Tooltip>
  );
};

const ChartPopover: FC = props => {
  const [isPopoverOpened, setIsPopoverOpened] = useState(false);
  return (
    <PopoverWrapper>
      <InfoIcon onClick={() => setIsPopoverOpened(!isPopoverOpened)} />
      <Popover onClose={() => setIsPopoverOpened(false)} opened={isPopoverOpened}>
        {props.children}
      </Popover>
    </PopoverWrapper>
  );
};

export { ChartPopover };
